export default "__VITE_ASSET__CmW3eQK0__"